
const selectorsCommonTH = {
  "selectors_clear": "ทั้งหมด",
  "selectors_orderAkpacaType_all": "ทั้งหมด",
  "selectors_orderAkpacaType_akpacaOnly": "เฉพาะเร่งด่วน",
  "selectors_orderAkpacaType_regular": "ปกติ",
  "selectors_orderStatus_all": "ทั้งหมด",
  "selectors_orderGroup_all": "ทุกกลุ่ม",
}

const selectorsPlaceholdersTH = {
  "selectors_grower_placeholder": "เลือกเกษตรกร",
  "selectors_car_placeholder": "เลือกรถ",
  "selectors_warehouse_placeholder": "เลือกคลังสินค้า",
  "selectors_teudaType_placeholder": "เลือกประเภทเอกสาร",
  "selectors_orderAkpacaType_placeholder": "เลือกประเภทคำสั่งซื้อ",
  "selectors_orderStatus_placeholder": "เลือกสถานะ",
  "selectors_orderGroup_placeholder": "เลือกกลุ่ม",
  "selectors_product_placeholder": "เลือกสินค้า",
  "selectors_size_placeholder": "เลือกขนาด",
  "selectors_package_placeholder": "เลือกบรรจุภัณฑ์",
  "selectors_palletType_placeholder": "เลือกพาเลท",
  "selectors_report_placeholder": "เลือกรายงาน",
}

const selectorsEmptyTH = {
  "selectors_grower_empty": "ไม่พบเกษตรกรที่ตรงกัน",
  "selectors_orderGroup_empty": "ไม่มีกลุ่ม",
  "selectors_car_empty": "ไม่พบรถที่ตรงกัน",
  "selectors_warehouse_empty": "ไม่พบคลังสินค้าที่ตรงกัน",
  "selectors_teudaType_empty": "ไม่พบประเภทที่ตรงกัน",
  "selectors_product_empty": "ไม่พบสินค้าที่ตรงกัน",
  "selectors_size_empty": "ไม่พบขนาดที่ตรงกัน",
  "selectors_package_empty": "ไม่พบบรรจุภัณฑ์ที่ตรงกัน",
  "selectors_palletType_empty": "ไม่พบพาเลทที่ตรงกัน",
  "selectors_report_empty": "ไม่พบรายงานที่ตรงกัน",
  "selectors_location_empty": "ไม่พบตำแหน่งที่ตรงกัน",
}

export const selectorsTranslationTH = {
  selectors: {
    ...selectorsCommonTH,
    ...selectorsPlaceholdersTH,
    ...selectorsEmptyTH,
  }
}
